import React from 'react'
import FieldsRenderer from '@rwitl/screen-renderer/lib/FieldsRenderer'
import { shimMissingComponentTypes } from './componentMap'
import injectStyles from 'react-jss'
import { getFieldTypes } from './../ScreenRenderer'

const styles = {
  dragger: {
    // Needs to match the styles of the main fields renderer
    width: 446,
  },
}

const DraggingFieldsScreenRenderer =
  ({ screenState, flatSchema, classes }) =>
  <div className={classes.dragger}>
    <FieldsRenderer
      screenState={screenState}
      flatSchema={flatSchema}
      componentMap={shimMissingComponentTypes(getFieldTypes(flatSchema))}
    />
  </div>

export default injectStyles(styles)(DraggingFieldsScreenRenderer)



// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/DraggingFieldsScreenRenderer/DraggingFieldsScreenRenderer.js